import React from "react";
import { Box, Link, Typography } from "@mui/material";

export const SherwebSetupGuideSteps: React.FC<{
  showSetupGuideTitle?: boolean;
}> = ({ showSetupGuideTitle = true }) => (
  <>
    {showSetupGuideTitle ? (
      <Typography
        sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 15, color: "#1a1a1a", mb: 1.5 }}
      >
        Setup Guide
      </Typography>
    ) : null}
    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 14, color: "#1a1a1a", mb: 2 }}>
      Create an API application in the{" "}
      <Link href="https://cumulus.sherweb.com" target="_blank" rel="noreferrer" sx={{ color: "#705d4a", fontWeight: 600 }}>
        Sherweb Partner Portal
      </Link>
      .
    </Typography>

    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 14, color: "#1a1a1a", mb: 1 }}>
      1. Open API settings
    </Typography>
    <Box component="ul" sx={{ m: 0, pl: 2.5, mb: 2, "& li": { mb: 0.75 } }}>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        In the Partner Portal left menu, go to <strong>Security</strong>, then <strong>APIs</strong>.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Add a new API application for Theo.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        If API access options are shown, enable <strong>Distributor API</strong> and <strong>Service Provider API</strong>.
      </Typography>
    </Box>

    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 14, color: "#1a1a1a", mb: 1 }}>
      2. Copy credentials
    </Typography>
    <Box component="ul" sx={{ m: 0, pl: 2.5, mb: 2, "& li": { mb: 0.75 } }}>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Copy the <strong>Client ID</strong>.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Copy the <strong>Client Secret</strong>.
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Copy the <strong>Subscription Key</strong>.
      </Typography>
    </Box>

    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5, fontWeight: 600 }}>
      Important:{" "}
      <Typography component="span" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5, fontWeight: 400 }}>
        Store the Client Secret securely after creating it. Sherweb may not show it again.
      </Typography>
    </Typography>
  </>
);
